import { CountryCode } from "../types/common";

/**
 * Returns true when the company name contains the country-specific limited
 * company designator as a standalone word (SE: "AB", FI: "Oy"), in any
 * position (prefix or suffix). Requires at least one other word so that a
 * name consisting solely of "AB"/"Oy" does not trigger a false positive.
 */
export function isLimitedCompany(
  name: string,
  countryCode: CountryCode,
): boolean {
  const parts = name.toLowerCase().trim().split(/\s+/);
  if (parts.length < 2) return false;
  switch (countryCode) {
    case CountryCode.SE:
      return parts.includes("ab");
    case CountryCode.FI:
      return parts.includes("oy");
    default: {
      const _exhaustive: never = countryCode;
      return _exhaustive;
    }
  }
}
